import { render } from "./FooterIcons.vue?vue&type=template&id=4bd01208&scoped=true"
import script from "./FooterIcons.vue?vue&type=script&lang=js"
export * from "./FooterIcons.vue?vue&type=script&lang=js"

import "./FooterIcons.vue?vue&type=style&index=0&id=4bd01208&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd01208"]])

export default __exports__